<script>
    import { connected } from "../store";
    import Menu from "../components/Menu.svelte";
    import {
        Container,
        Row,
        Col,
        Card
    } from "sveltestrap";
    import { _ } from "svelte-i18n";
</script>

{#if $connected}
    <Menu showAlert="true" />
{/if}

<Container>
    <Row>
        <Col lg="2"></Col>
        <Col lg="8">
            <Card body class="bg-dark border-danger">
                <h1 class="display-1">
                    {$_("routes.NotFound.pageNotFound")}<br />
                </h1>
                <h2>
                    <small class="text-muted">{$_("routes.NotFound.seemToBeLost")}</small>
                </h2>
                <a href="/">{$_("routes.NotFound.clickHere")}</a>
            </Card>
        </Col>
        <Col lg="2"></Col>
    </Row>
</Container>